module.exports = __webpack_public_path__ + "img/banner.68dff9b7.png";